import { Injectable } from '@angular/core'
import { HttpService } from '@surgetech-eu/core'
import { Observable } from 'rxjs'

export interface OrganizationInfo {
    active: boolean
    attributes: {
        sapCode: string
        vatCode: string
    }
    companyId: string
    companyName: string
    companyType: string
}
@Injectable()
export class OrganizationsService {
    constructor(private http: HttpService) {}

    getOrganizations(): Observable<Record<string, OrganizationInfo[]>> {
        return this.http.get<Record<string, OrganizationInfo[]>>('/organizations')
    }
}
